import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { UserService } from '../services/user/user.service';
import { environment } from '@src/environments/environment';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const _auth = inject(AuthService);
  const _user = inject(UserService);

  const isApiCall = req.url.startsWith(environment.apiUrl);
  
  if (!isApiCall) {
    return next(req);
  }

  const isPublicRoute = req.url.includes('/supplier-pre-registrations') ||
    req.url.includes('/product-categories') ||
    req.url.includes('/login/password-recovery') ||
    req.url.includes('/login/reset-password') ||
    req.url.includes('/login/user-login');

  if (!_auth.isUserAuthenticated() && !isPublicRoute) {
    _user.clearUser();
    _auth.logout();
  }

  const token = _auth.getToken();
  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(req).pipe(
    catchError((error) => {
      if ((error.status === 401 || !_auth.isUserAuthenticated()) && !isPublicRoute) {
        _user.clearUser();
        _auth.logout();
      }
      return throwError(() => error);
    }),
  );
};
